export default __webpack_public_path__ + "static/media/reward-bg.89e95f73.png";